import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { DefaultPlayer as Video } from 'react-html5video'
import VisibilitySensor from 'react-visibility-sensor'

import phone_img from '../../img/iphone.png'
import Videofile from '../../video.mp4'
import Poster from './poster.png'

import './intro.css'
import '../../App.css'

import 'react-html5video/dist/styles.css'

class IntroSection extends Component {
  pauseVideo = isVisible => {
    const node = this.textInput
    if (!isVisible) {
      node.videoEl.pause()
    } else {
      node.videoEl.play()
    }
  }
  render() {
    return (
      <div>
        <Container className="VideoIntroSection">
          <Row className="videosection">
            <Col xs="12" sm="6" className="video header-graphic show-phone">
              <div className="video-wrapper">
                <Video
                  autoPlay
                  muted
                  loop
                  ref={ref => {
                    this.textInput = ref
                  }}
                  poster={Poster}
                  controls={['Fullscreen']}
                  className="home-video"
                >
                  <source src={Videofile} type="video/mp4" />
                </Video>
                <VisibilitySensor onChange={this.pauseVideo} />
              </div>
              <div className="phone-mask">
                <img
                  src={phone_img}
                  alt="phone_img"
                  className="phoneWrapper img-fluid graphic"
                />
              </div>
            </Col>
            <Col xs="12" sm="6" className="intro-description">
              <div className="title1">
                TobeyApp is a comprehensive Lifestyle Mangement Platform for
                Placemakers:
              </div>
              <div className="title2">
                master planned, active adult and luxury lifestyle club
                communities.
              </div>
            </Col>
          </Row>

          <Row className="fourBlocks-first">
            <Col xs="12" sm="5">
              <div className="subtitle">
                Put your community experience where residents live, in their
                hand.
              </div>
              <div className="detail">
                Imagine a comprehensive, fully-branded mobile app to explore,
                reserve and experience your entire community lifestyle.  If a
                polished, high-end and secure user experience matters to you and
                your residents; a native mobile application is the only way to
                go.
              </div>
            </Col>
            <Col xs="12" sm="2" className="virtical-box1">
              <Row className="virtical-line1">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Row>
            </Col>
            <Col xs="12" sm="5">
              <div className="subtitle">
                The fastest solution to satisfy resident needs.
              </div>
              <div className="detail">
                Activate residents with seamless solutions to reserve, request,
                pay, share and engage with your amenities.  With the most
                one-tap features available, Tobey enables your residents to
                satisfy their needs faster than any other community platform on
                the market.
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12" sm="4" />
            <Col xs="12" sm="4">
              <Row className="horizantal-line" />
            </Col>
            <Col xs="12" sm="4" />
          </Row>
          <Row className="fourBlocks-second">
            <Col xs="12" sm="5">
              <div className="subtitle">
                Intuitive curation matches events, programs, offers and
                amenities to each resident.
              </div>
              <div className="detail">
                Residents are quickly overwhelmed; it’s easy to hesitate or
                choose nothing at all. Tobey’s personalization engine promises
                more: To give your residents exactly what they want most, while
                spending as little energy as possible on making a choice.
              </div>
            </Col>
            <Col xs="12" sm="2" className="virtical-box2">
              <Row className="virtical-line2">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </Row>
            </Col>
            <Col xs="12" sm="5">
              <div className="subtitle">Tobey is ready to roll in 30 days.</div>
              <div className="detail">
                The team at Tobey is complete with seasoned on-boarding and
                on-going support.  Tobey can be branded, fully stocked with your
                events and amenities and ready to launch to your community
                within 30 days.
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default IntroSection



// WEBPACK FOOTER //
// ./src/components/IntroSection/index.js